import React, { FC, useState, useEffect } from 'react'

import { EuiFlyoutHeader, EuiFlyoutBody, EuiFlyoutFooter, EuiTitle, EuiButton, EuiFlexGroup, EuiFlexItem, EuiFormRow, EuiFieldText } from '@elastic/eui'
import AcFlyout from 'components/AcFlyout'

import BlueprintEditWarning from 'features/planner/components/BlueprintEditWarning'

export interface EditPageTitleFlyoutProps {
  currentTitle: string
  defaultTitle: string
  onSave: (title: string) => void
  onClose: () => void
  isLoading?: boolean
  fullWidth?: boolean
  showBlueprintWarning?: boolean
}

const EditPageTitleFlyout: FC<EditPageTitleFlyoutProps> = ({ currentTitle, defaultTitle, onSave, onClose, isLoading = false, fullWidth = false, showBlueprintWarning = false }) => {
  const [title, setTitle] = useState(currentTitle)

  useEffect(() => {
    setTitle(currentTitle)
  }, [currentTitle])

  const handleSave = () => {
    onSave(title)
  }

  const isSaveDisabled = title.trim().length <= 0 || isLoading
  const flyoutTitle = currentTitle && currentTitle.trim().length > 0 ? `Edit ${currentTitle}` : `Edit ${defaultTitle}`

  return (
    <AcFlyout onClose={onClose} size='m'>
      <EuiFlyoutHeader>
        <EuiTitle size='m'>
          <h2>{flyoutTitle}</h2>
        </EuiTitle>
      </EuiFlyoutHeader>

      <EuiFlyoutBody>
        <BlueprintEditWarning show={showBlueprintWarning} />
        <EuiFormRow label='Title' style={fullWidth ? { maxWidth: '40%', minWidth: '300px' } : undefined}>
          <EuiFieldText fullWidth={fullWidth} value={title} onChange={e => setTitle(e.target.value)} disabled={isLoading} placeholder={defaultTitle} />
        </EuiFormRow>
      </EuiFlyoutBody>

      <EuiFlyoutFooter>
        <EuiFlexGroup justifyContent='flexStart' gutterSize='l'>
          <EuiFlexItem grow={false}>
            <EuiButton onClick={onClose} disabled={isLoading}>
              Cancel
            </EuiButton>
          </EuiFlexItem>
          <EuiFlexItem grow={false}>
            <EuiButton fill onClick={handleSave} disabled={isSaveDisabled} isLoading={isLoading}>
              Save
            </EuiButton>
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiFlyoutFooter>
    </AcFlyout>
  )
}

export default EditPageTitleFlyout
